// Autogenerated file
export const trackerSegmentEmulatingLogStatusesEnum = {
    Success: "Success",
    CouldNotBuildRoute: "CouldNotBuildRoute",
    ArithmeticError: "ArithmeticError",
    SaveError: "SaveError",
    SuspiciousRoute: "SuspiciousRoute",
};
export const trackerSegmentEmulatingLogStatuses = [
    { label: "Успешно", value: "Success" },
    { label: "Не удалось построить маршрут", value: "CouldNotBuildRoute" },
    { label: "Ошибка при расчете расстояния между координатами", value: "ArithmeticError" },
    { label: "Ошибка при сохранении в бд", value: "SaveError" },
    { label: "Ошибка при сохранении в бд", value: "SuspiciousRoute" },
];
